export type PlanItemType = "video" | "file" | "notebook" | "marimo";

export type PlanItem = {
  itemType: PlanItemType | string;
};

export type PlanSubtopic = {
  items: PlanItem[];
};

export type PlanTopic = {
  subtopics: { [subtopicId: string]: PlanSubtopic };
};

export type LevelCounts = { [level: string]: number };

export type OriginalSubtopic = {
  id?: string;
  mcq?: LevelCounts;
  coding?: LevelCounts;
  optionalMcq?: LevelCounts;
  optionalCoding?: LevelCounts;
};

export type OriginalTopic = {
  id?: string;
  subtopics?: OriginalSubtopic[];
};

export type SubjectPlanCounts = {
  videos: number;
  notes: number;
  notebooks: number;
  mcqs: number;
  coding: number;
  optionalMcqs: number;
  optionalCoding: number;
};

function sumLevelCounts(values: LevelCounts | undefined): number {
  if (!values || typeof values !== "object") {
    return 0;
  }
  return Object.values(values).reduce(
    (total, count) => total + (parseInt(String(count), 10) || 0),
    0
  );
}

export function isNotebookItemType(itemType: string): boolean {
  return itemType === "notebook" || itemType === "marimo";
}

export function countSubjectPlanItems(
  items: { [topicId: string]: PlanTopic },
  originalTopics: OriginalTopic[] = []
): SubjectPlanCounts {
  const counts: SubjectPlanCounts = {
    videos: 0,
    notes: 0,
    notebooks: 0,
    mcqs: 0,
    coding: 0,
    optionalMcqs: 0,
    optionalCoding: 0,
  };

  Object.keys(items).forEach((topicId) => {
    Object.keys(items[topicId].subtopics).forEach((subtopicId) => {
      const subtopic = items[topicId].subtopics[subtopicId];
      subtopic.items.forEach((item) => {
        if (item.itemType === "video") {
          counts.videos += 1;
        } else if (item.itemType === "file") {
          counts.notes += 1;
        } else if (isNotebookItemType(String(item.itemType))) {
          counts.notebooks += 1;
        }
      });

      const topic = originalTopics.find((entry) => entry.id === topicId);
      const original = topic?.subtopics?.find((entry) => entry.id === subtopicId);
      counts.mcqs += sumLevelCounts(original?.mcq);
      counts.coding += sumLevelCounts(original?.coding);
      counts.optionalMcqs += sumLevelCounts(original?.optionalMcq);
      counts.optionalCoding += sumLevelCounts(original?.optionalCoding);
    });
  });

  return counts;
}
